import { Components } from 'formiojs'

const Select = Components.components.select

export class DirectoryEntryMultiSelectComponent extends Select {
  static schema(...extend) {
    return Select.schema({
      type: 'directoryEntryMultiSelect',
      label: 'Directory Entry Multi Select',
      key: 'directoryEntryMultiSelect',
      multiple: true
    })
  }

  static get builderInfo() {
    return {
      title: 'Verzeichniseintrag Mehrfachauswahl',
      icon: 'th-list',
      documentation: '/userguide/#select',
      weight: 0,
      schema: DirectoryEntryMultiSelectComponent.schema()
    }
  }

  constructor(component, options, data) {
    super(component, options, data)
  }

  init() {
    super.init()
  }

  render(content) {
    const container = document.createElement('div')
    const actionsContainer = document.createElement('div')
    const refreshButton = document.createElement('button')
    const createNewEntryLink = document.createElement('a')

    actionsContainer.style.display = 'flex'
    actionsContainer.style.gap = '0.25rem'
    actionsContainer.style.marginTop = '0.5rem'

    refreshButton.setAttribute('ref', this.id + '-refresh')
    refreshButton.type = 'button'
    refreshButton.className = 'btn btn-secondary'
    refreshButton.innerHTML = '<i class="fa fa-refresh"></i>'

    createNewEntryLink.href = `/directories/${this.component.verzeichnis}?add=true`
    createNewEntryLink.target = '_blank'
    createNewEntryLink.className = 'icon-link p-2 flex items-center gap-1'
    createNewEntryLink.innerHTML = '<i class="fa fa-plus"></i>Neuen Eintrag erstellen'

    actionsContainer.appendChild(refreshButton)
    actionsContainer.appendChild(createNewEntryLink)

    container.innerHTML = super.render(content)

    const componentElement = container.firstElementChild

    if (componentElement) {
      componentElement.appendChild(actionsContainer)
    }

    return container.innerHTML
  }

  setItems(items: any[], fromSearch) {
    const currentValue = this.getValue()
    const selectedIds = Array.isArray(currentValue) ? currentValue.map(String) : []
    const options = (this.selectOptions as unknown as any[]) || []

    selectedIds.forEach((id) => {
      if (!items?.find((i) => String(i.id) === id)) {
        const existing = options.find((opt) => String(opt.value?.id) === id)?.value

        if (existing) {
          items.unshift(existing)
        }
      }
    })

    if (items && items.length > 0) {
      items.sort((a, b) => {
        const labelA = String((this as any).itemTemplate(a))
          .replace(/(<([^>]+)>)/gi, '')
          .trim()
        const labelB = String((this as any).itemTemplate(b))
          .replace(/(<([^>]+)>)/gi, '')
          .trim()

        return labelA.localeCompare(labelB)
      })
    }

    // @ts-expect-error making sure setItems exists
    if (!super.setItems) {
      return
    }

    // @ts-expect-error we know this is a Select component
    return super.setItems(items, fromSearch)
  }
  normalizeValue(value, flags = {}) {
    // Handle backward compatibility: convert old selectboxes format { "id": boolean } to array
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return Object.keys(value).filter((k) => value[k])
    }

    return super.normalizeValue(value)
  }

  attach(element) {
    this.loadRefs(element, {
      [this.id + '-refresh']: 'single'
    })

    this.addEventListener(this.refs[this.id + '-refresh'], 'click', () => {
      super.updateItems()
    })

    return super.attach(element)
  }
}
